import clsApiPost from '@cls/clsApiPost'

// import clsRelationIncassoApi from '@/features/relation/incasso/api'; 

class clsRelationIncassoAttachmentsApi extends clsApiPost {

    /**
     * 
     * @param {} formData 
     * @returns 
     */
    uploadAttachment(formData) {
        return this.upload(formData, 'upload');
    }

    /**
     * Remove an attachment
     */
    removeAttachment(id) {
        return this.post(`remove`, {id: id}); 
    }

    /**
     * download an attachment
     */
    async loadAttachment(id, bDownload) {
        if (bDownload) {
            return await this.downloadPost(`load`, {id: id});  
        }
        return await this.postRaw(`load`, {id: id});  
    }

}

export default clsRelationIncassoAttachmentsApi;
